import React, { Suspense, useContext, useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import { GVarState } from "./StoreState/Gstate";
import { socket } from "./socket";
import {
  useSearchParams,
  useNavigate,
  createSearchParams,
  Link,
} from "react-router-dom";
import {
  AllFloor,
  FilterAdd,
  HideDropdown,
  goFullScreen,
} from "./Action/Action";
// import D3 from "./3d/D3";

import { receivedTime, sentTime, setActiveClick, setReceivedTime, setSentTime } from "./StoreState/Var";
import { localSocket } from "./gopro/Connect";
import { getMallList } from "./Compo/Category/GetApiData";
import gsap from "gsap";
let PointType = {};
const D3 = React.lazy(() => import('./3d/D3'))
let setTimeInVar;
function Janani() {

  let g = useContext(GVarState);
  const [AllMall, setAllMall] = useState(null)
  const [animationStop, setanimationStop] = useState(false)
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  //received mobile data 
  useEffect(() => {
    window.addEventListener("message", function (message) {
      let datas = message.data
      if (datas.type !== 'webpackWarnings') {
        // let ReactNativeData=JSON.parse(message.data)
        if (message.data?.type == "reactNative") {
          alert(message.data.message);
          // window.postMessage(JSON.stringify({msg:"mydatas"}), '*')
          window.ReactNativeWebView.postMessage(JSON.stringify({ msg: "mydatas" }))
        }
      }

      // console.log("t his is ",message.data);
      // console.log("t his is ",message);
    });
  }, [])


  //endt react mobile data 
  // 


  // check mall Id and View Type
  useEffect(() => {
    if (searchParams.get("m") && searchParams.get("v")) {
      if (searchParams.get("v") === "1") {
        g.setViewType("webview");
      } else if (searchParams.get("v") === "2") {
        g.setViewType("3d");
      } else {
        g.setViewType("");
      }
      g.setMallType(searchParams.get("m"));
    } else {
      g.setMallType(""); // w mines webview only show 
      g.setViewType("");
    }
    if (searchParams.get("d") === "m") {
      g.setDevice(true)
    }
  }, [searchParams.get("v"), searchParams.get("m"), searchParams.get("d")]);

  useEffect(() => {
    let search = window.location.search
    if (search == "") {
      console.log("huaa ");
      g.setnodePoint(null)
    }
    if (searchParams && (g.viewType === "webview" || g.viewType === "3d")) {
      let v = searchParams.get("v");
      let to = searchParams.get("to");
      let from = searchParams.get("from");
      let elevator = searchParams.get("elevator");
      let escalator = searchParams.get("escalator");
      let selectData = searchParams.get("selectData");
      if (to && from) {
        if (elevator === "true" && escalator === "true") {
          g.setPointType({
            ...g.PointType,
            elevator: false,
            escalator: false,
            stair: true,
          });
        } else if (elevator === "true") {
          g.setPointType({
            ...g.PointType,
            elevator: false,
            escalator: true,
            stair: true,
          });
          PointType = { elevator: false, escalator: true, stair: true };
        } else if (escalator === "true") {
          g.setPointType({
            ...g.PointType,
            elevator: true,
            escalator: false,
            stair: true,
          });
          PointType = { elevator: true, escalator: false, stair: true };
        } else {
          g.setPointType({
            ...g.PointType,
            elevator: false,
            escalator: false,
            stair: false,
          });
          PointType = { elevator: false, escalator: false, stair: false };
        }
        if (to) {
          to = to.split(",");
        }
        if (from) {
          from = from.split(",");
        }
        let To = to;
        let From = from;

        let raw = {
          start: { x: +To[0], y: +To[1], z: +To[2] },
          end: { x: +From[0], y: +From[1], z: +From[2] },
          stape: PointType,
        };
        localStorage.setItem("ids", socket.id)
        if (localStorage.getItem("mallid" + g.mallType)) {
          localSocket("findpath", { raw, id: 1 }, findpath)
        } else {
          socket.emit(`findpath`, { raw, id: socket.id })

        }


      }

      if (selectData) {
        let d = atob(selectData).trim();
        // let data = g.nodePoint[`${d}`];
        if (localStorage.getItem("mallid" + g.mallType)) {
          localSocket("endpointsendAndReceive", ({ id: 1, data: d }), endpointrecive)

        } else {
          socket.emit(`endpointsend`, ({ id: socket.id, data: d }))
        }
      }
      if (to || from || selectData) {
        if (setTimeInVar) {
          clearTimeout(setTimeInVar)
        }
        setTimeInVar = setTimeout(() => {
          godefaultfloor()
          killpath("kill")
        }, 120000)
      }
    }
  }, [searchParams]);
  function godefaultfloor() {
    let defaultStore = localStorage.getItem(g.mallType + "defaultStore");
    if (defaultStore) {
      defaultStore = JSON.parse(defaultStore)
      g.setCurrentFloor(Number(defaultStore.z))
    }
  }
  useEffect(() => {
    var ReceveMallData;
    if (g.nodePoint == null && g.mallType && searchParams) {

      let selectData = searchParams.get("selectData");


      var startDate = new Date();
      ReceveMallData = (data) => {
        // console.log(Object.values(data.nodePoint)[0], "data.nodePoint[0]?.point?.extra?.miniApp");
        if (Object.values(data.nodePoint)[0]?.point?.extra?.miniApp) {
          localStorage.setItem("miniApp", `?v=2&m=${g.mallType}`);
        } else {
          localStorage.removeItem("miniApp");
          // window.location="/"
          setTimeout(() => {
            navigate(`/error`)
          }, 0)
        }

        var endDate = new Date();
        var seconds = (endDate.getTime() - startDate.getTime()) / 1000;

        g.setnodePoint(data.nodePoint);
        g.setnodeLine(data.nodeLine);
        g.setwidth(data.width);
        g.setheight(data.height);
        g.setw(data.w);
        g.seth(data.h);
        let imageData = [];
        for (let i = 0; i < data.FloorImg.length; i++) {
          const image = data.FloorImg[i];
          let img = {
            src: image.FloorUrl,
            width: data.width,
            height: data.height,
          };
          imageData.push({
            ...image,
            FloorUrl: img,
          });
        }
        g.setFloorImg(imageData);
        let params = {};
        searchParams.forEach((d, i) => {
          params[i] = d;
        });
        params.id = socket.id ?? "offline";
        navigate({
          pathname: "/",
          search: `?${createSearchParams(params)}`,
        });
        let defaultStore = localStorage.getItem(g.mallType + "defaultStore");
        if (defaultStore) {
          defaultStore = JSON.parse(defaultStore)
          g.setCurrentFloor(Number(defaultStore.z))
        } else {
          if (imageData[0].FloorNumber && !selectData) {
            let findFloor = imageData.findIndex(img => img.FloorNumber === 0)
            g.setCurrentFloor(Number(findFloor))
            // socket.emit("floorchange", { id: socket.id, number: findFloor })
          } else {
            g.setCurrentFloor(0)

          }

        }
      }
      if (localStorage.getItem("mallid" + g.mallType)) {
        localSocket("connectWithMall", { mallId: g.mallType }, ReceveMallData);
        
      } else {
        socket.emit("connectWithMall", { mallId: g.mallType });
        localSocket("connectWithMall", { mallId: g.mallType }, ReceveMallData);
      }





      socket.on("ReceveMallData", (d) => {
        ReceveMallData(d)
      });
      // alert(socket)

    } else {
      // 

    }
    return () => {
      socket.off("ReceveMallData", ReceveMallData);
    }
  }, [g.nodePoint, g.mallType, searchParams]);

  // useEffect(() => {
  //   socket.emit("floorchange", { id: socket.id, number: g.CurrentFloor })
  //   g.setCurrentFloor(g.CurrentFloor)
  //   
  // }, [g.CurrentFloor])
  function endpointrecive(data) {
    g.setCurrentFloor(data.z)
    g.setShapZooomPosition(null)
    g.setselectPointB({ ...data })
    g.setSelectShapData({ ...data })
    g.setStartAndEndPart(false);
    g.setpath([]);
    g.setEndSearchInput({
      name: data.point.LocationName.text,
      point: data.point,
    });
    g.setStartSearchInput(null);
  }
  function findpath(data) {
    if (data.path.length <= 1) {
      if (!g.Device) {
        alert("please try different start and end points")
      }
    }
    if (g.nodePoint && data.path.length > 1) {
      g.setActiveFloor(0)
      g.setfloorRootPaths(data.floorRoot)
      g.setCurrentRoots(data.roots)
      g.setpathAllPoint(data.path)
      // g.setAdsData(FilterAdd(data.path, g))
      g.setStapeByStape(data.StapeByStape);
      g.setpath(data.pathLine);
      g.setCurrentFloor(data.pathLine[0]?.a?.z);
      g.setNextPrev(data.floorNumber);
      // g.setNextPrev(AllFloor(data.path, g));
      g.setStartAndEndPart(true)
      g.setselectPointA(data.start)
      g.setselectPointB(data.end)
      g.setSelectShapData(data.end)
      let start = `${data.start.point.x},${data.start.point.y},${data.start.point.z}`
      let end = `${data.end.point.x},${data.end.point.y},${data.end.point.z}`
      // let end = `${data.path[data.path.length - 1].x},${data.path[data.path.length - 1].y},${data.path[data.path.length - 1].z}`
      // console.log(g.nodePoint[end].point,g.nodePoint[start].point);
      g.setEndSearchInput({ name: g.nodePoint[end].point.LocationName.text, point: g.nodePoint[end].point })
      g.setStartSearchInput({ name: g.nodePoint[start].point.LocationName.text, point: g.nodePoint[start].point })
    }
  }
  function killpath(data) {
    if (data === "kill") {
      godefaultfloor()
      g.setpath([])
      g.setStapeByStape(null);
      g.setNextPrev(null);
      g.setStartAndEndPart(false)
      g.setselectPointA(undefined)
      g.setselectPointB(undefined)
      g.setSelectShapData(null)
      g.setEndSearchInput(null)
      g.setStartSearchInput(null)
    }
  }
  function floor(data) {
    g.setCurrentFloor(data);
  }
  function nextandpre(data) {
    console.log("isme aaya ");
    if (data === "next") {
      g.setCurrentFloor(g.NextPrev[g.ActiveFloor + 1])
      g.setActiveFloor(g.ActiveFloor + 1)
    }
    if (data === "pre") {
      g.setCurrentFloor(g.NextPrev[g.ActiveFloor - 1])
      g.setActiveFloor(g.ActiveFloor - 1)
    }
  }
  useEffect(() => {
    socket.on(`endpointrecive${socket.id}`, endpointrecive)
    socket.on(`findpath${socket.id}`, findpath);
    socket.on(`killpath${socket.id}`, killpath)
    socket.on(`floor${socket.id}`, floor)

    return () => {
      socket.off(`endpointrecive${socket.id}`, endpointrecive)
      socket.off(`findpath${socket.id}`, findpath);
      socket.off(`killpath${socket.id}`, killpath)
      // socket.off(`nextandpre${socket.id}`, nextandpre)
    }

  }, [searchParams])
  useEffect(() => {
    if (g.NextPrev) {
      socket.on(`nextandpre${socket.id}`, nextandpre)
    }
    return () => {
      socket.off(`nextandpre${socket.id}`, nextandpre)
    }
  }, [g.ActiveFloor, g.NextPrev])

  // mousemovment event

  useEffect(() => {
    window.addEventListener("mousemove", () => {
      setActiveClick(false)
    })

    window.addEventListener("mousedown", () => {
      goFullScreen()
      setActiveClick(true)
    })
    return () => {
      window.removeEventListener("mousemove", null)
      window.removeEventListener("mousedown", null)
    }

  }, [])


  useEffect(() => {
    async function CheckMall() {
      let mallId = localStorage.getItem("miniApp")
      if (mallId) {
        // navigate({
        //   pathname: "/",
        //   search: `?v=2&m=${mallId}`
        // });
        navigate(`${mallId}`)
      } else {
        let mallList = await getMallList()
        setAllMall(mallList?.data?.Response[0]?.Oken_Onboarding)

      }
    }
    CheckMall()

  }, [])
  if (g.viewType === "3d") {
    return <Suspense fallback={<div>Loading</div>}>
      <D3 />
    </Suspense>;
  }

  return (
    <div className="flex w-full h-screen  p-60 text-lg">
      <div className="w-full">
        <label htmlFor="countries" className="block mb-2 text-3xl font-medium text-gray-900 dark:text-white">Select Your Mall</label>
        <select id="countries" onChange={(e) => {
          navigate({
            pathname: "/",
            search: `?v=2&m=${e.target.value}`
          });
        }} className="bg-gray-50 border border-gray-300 text-gray-900 text-3xl  rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
          <option selected>Choose a Mall</option>
          {window.innerWidth > 600 &&
            AllMall?.map((map, index) => {
              return <option key={index} className="m-5" value={map.oko_Row_Code} onSelect={() => {
                navigate({
                  pathname: "/",
                  search: `?v=2&m=${map.oko_Row_Code}`
                });
              }}>{map.oko_Row_Desc} </option>
            })
          }
        </select>
      </div>
      <section>
        <img src="./images/Group.svg" className=' absolute bottom-20 right-20 -z-10 opacity-50 transform ' id="imagerotation" alt="" />
      </section>

    </div>
  );
}

export default Janani;
